import * as Parse from 'parse';
import { FileModel, StringModel } from '.';
import { ModelDecorator } from '../decorators';

export default class Usp extends Parse.Object {

    @ModelDecorator.Variable
    public name: string;

    @ModelDecorator.Variable
    public content: StringModel;

    @ModelDecorator.Variable
    public title: StringModel;

    @ModelDecorator.Variable
    public subtitle: StringModel;

    @ModelDecorator.Variable
    public image: FileModel;

    constructor() {
        super('Usp')
        this.name = '';
        this.title = new StringModel();
        this.subtitle = new StringModel();
        this.image = new FileModel();
        this.content = new StringModel();
    }

    // tslint:disable-next-line:member-ordering
    public static async deleteAllUsps(usps: Usp[]) {
        const subobjectForDelete: any[] = [];
        const mainobjectForDelete: any[] = [];
        usps.forEach((u) => {
            subobjectForDelete.push(u.content);
            mainobjectForDelete.push(u);
        })
        await Usp.destroyAll(subobjectForDelete);
        await Usp.destroyAll(mainobjectForDelete);
    }

    // tslint:disable-next-line:member-ordering
    public static async searchUsp(s: string, limit: number, skip: number, isCount = false) {
        const searchQuery = new Parse.Query(Usp)
        searchQuery.descending('date')
        searchQuery.include(['content','title','subtitle','iamge'])
        searchQuery.matches('name', new RegExp(s, 'i'), null)
        if (isCount) {
            return searchQuery.count();
        } else {
            searchQuery.limit(limit);
            searchQuery.skip(skip);
            return searchQuery.find();
        }
    }

    // tslint:disable-next-line:member-ordering
    public static async getUspsCount() {
        return new Parse.Query(Usp).count()
    }

    // tslint:disable-next-line:member-ordering
    public static async loadUsp(uspId: string) {
        const usp = await new Parse.Query(Usp)
            .include(['content','title','subtitle','image','image.alt'])
            .get(uspId)
        if(!usp.title){
            usp.title = new StringModel();
        }
        if(!usp.subtitle){
            usp.subtitle = new StringModel();
        }
        if(!usp.image){
            usp.image = new FileModel();
        }
        return usp
    }

    // tslint:disable-next-line:member-ordering
    public static async loadUsps(skip = 0, limit = 25) {
        return new Parse.Query(Usp)
            .descending('date')
            .include(['content','title','subtitle','image','image.alt'])
            .limit(limit)
            .skip(skip)
            .find()
    }

    public async saveFullUsp() {
        await this.content.save();
        await this.title.save();
        await this.subtitle.save();
        await this.image.alt.save();
        await this.image.save();
        await this.save();
    }

}

Parse.Object.registerSubclass('Usp', Usp);


// WEBPACK FOOTER //
// ./src/models/Usp.ts